
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LayoutComponent, AuthLayoutComponent } from './main';
import { CedantIdResolverService, ProgramIdResolverService } from './route-resolver-service/route-resolver.service';

export const routes: Routes = [{
  path: '', component: LayoutComponent,
  children: [
    {
      path: '',
      loadChildren: './style-guide/style-guide.module#StyleGuideModule'
    },
    {
      path: '',
      loadChildren: './insights/insights.module#InsightsModule'
    },
    {
      path: '',
      loadChildren: './settings/settings.module#SettingsModule'
    },
    {
      path: '',
      loadChildren: './cedant/cedant.module#CedantModule'
    },
    {
      path: 'cedant/:cedantId',
      loadChildren: './program/program.module#ProgramModule',
      resolve: {
        cedantId:  CedantIdResolverService
      }
    },
    {
      path: 'cedant/:cedantId/program/:programId',
      loadChildren: './contract/contract.module#ContractModule',
      resolve: {
        cedantId:  CedantIdResolverService,
        programId: ProgramIdResolverService
      }
    }
  ]
}, {
  path: '',
  component: AuthLayoutComponent,
  children: [{
    path: 'session',
    loadChildren: './session/session.module#SessionModule'
  }]
}, {
  path: '**',
  redirectTo: 'session/404'
}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
